<template>
  <div>
    <div class="form-group">
      <SelectField
        label=""
        placeholder="Välj max hyra"
        :floatingLabel="false"
        :options="availablerentAmounts"
        v-model="value__"
        size="md"
        @update:modelValue="change"
      />
    </div>
  </div>
</template>
<script>
import SelectField from '@/components/ui/form/select';
import { mapGetters } from 'vuex';

export default {
  components: { SelectField },
  props: {
    modelValue: {
      // Change "value" to "modelValue" (Vue 3 convention)
      type: Number,
    },
    activeType: {
      type: String,
    }
  },
  data() {
    return {
      value__: this.modelValue,
    };
  },

  computed: {
    /**
     * Alternativ att välja bland
     */
    availablerentAmounts() {
      if (this.activeType != 'apartment') return this.$store.getters.config.rentAmountsOther;

      return this.$store.getters.config.rentAmounts;
    },
  },
  watch: {
    /**
     * När v-model ändras, ska även det interna värdet ändras.
     * Detta sker t.ex. när man klickar på "Rensa"-knappen
     */
    modelValue(newValue) {
      this.value__ = newValue;
    },
  },
  methods: {
    change() {
      this.$emit('update:modelValue', this.value__);
    },
  },
};
</script>
